import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    Autocomplete,
    Box,
    Grid,
    Grow,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
    TextField,
    Typography,
} from "@mui/material";

import { getBreakDownPlaceByGroupId } from "../../store/actions/GeneralTableActions";
import {
    getBreakDownReasonPlaces,
    getPlants,
    getBreakdownGroups,
    addBreakdownReasonPlace,
    updateBreakdownReasonPlace,
    deleteBreakdownReasonPlace,
} from "../../store/actions/BreakdownReasonPlaceActions";

import { commonSort } from "../../common";
import AddButton from "../../components/AddButton/AddButton";
import SearchBar from "../../components/SearchBar/SearchBar";
import TableButtons from "../../components/Button/TableButtons";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import Modal from "../../components/Modal/Modal";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";

export default function BreakdownReasonPlace() {
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();
    const { BreakdownReasonPlace } = useSelector(
        (BreakdownReasonPlace) => BreakdownReasonPlace
    );

    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [editable, setEditable] = useState(false);
    const [editableRow, setEditableRow] = useState("");
    let [addGroupID, setAddedGroupID] = useState("");
    const [plantList, setPlantList] = useState([]);
    const [disableButton, setDisableButton] = useState(false);

    useEffect(() => {
        getPlantCodeHandler();
        getGroupCodeHandler();
        loadHandler();
    }, []);

    useEffect(() => {
        if (BreakdownReasonPlace?.breakdownReasonPlaces?.length) {
            setInitialRows(BreakdownReasonPlace.breakdownReasonPlaces);
            setRows(BreakdownReasonPlace.breakdownReasonPlaces);
            BreakdownReasonPlace.breakdownReasonPlaces = {};
            setPageLoaded(true);
        }
        if (BreakdownReasonPlace?.plants?.resultObject) {
            setPlantList(BreakdownReasonPlace.plants.resultObject);
        }
        if (BreakdownReasonPlace?.breakdownGroups?.resultObject) {
            setGroupList(BreakdownReasonPlace.breakdownGroups.resultObject);
        }
        if (BreakdownReasonPlace.isTaskUpdated) {
            setEditableRow(false);
            setDisableButton(false);
            loadHandler();
        }
    }, [BreakdownReasonPlace]);

    const loadHandler = () => {
        dispatch(getBreakDownReasonPlaces());
    };

    const getPlantCodeHandler = () => {
        dispatch(getPlants());
    };

    //get group names
    const [groupList, setGroupList] = useState([]);
    const getGroupCodeHandler = () => {
        dispatch(getBreakdownGroups());
    };

    const renderTableCell = (rowItems, isSortingAction = true) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            if (item.id === "Actions") {
                return <TableCell align="center">{t("Actions")}</TableCell>;
            } else {
                return isSortingAction ? (
                    <TableCell align="center" id={`brp_TableHead_${index}`}>
                        <TableSortLabel
                            active={sortColumn === item.id}
                            direction={directionType}
                            onClick={() =>
                                handleSort(cloneObject(initialRows), item.id)
                            }
                            style={{ paddingLeft: 25 }}
                        >
                            {item.label}
                        </TableSortLabel>
                    </TableCell>
                ) : (
                    <TableCell align="center">{item.label}</TableCell>
                );
            }
        });
    };

    //dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (row, column) => {
        const sortedList = commonSort(row, column);
        setSortOrder(sortedList[0]);
        setSortColumn(sortedList[1]);
        setInitialRows(sortedList[2]);
        setRows(sortedList[2]);
    };

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    const newGroupID = (groupName) => {
        if (groupName.length > 0) {
                setError({ ...error, breakdownReasonGroupText: "" });
        
        }
        else {
        
                setError({ ...error, breakdownReasonGroupText: t("SelectABreakdownReasonGroup") });
    
        }
        if (groupName != null) {
            const filteredGroup = groupList.filter(
                (item) =>
                    item.breakdownReasonGroupLocalizationName === groupName ||
                    item.name === groupName
            );
            getPlaceCodeHandler(filteredGroup[0].id);
            setAddedGroupID(filteredGroup[0].id);
            return filteredGroup[0].id;

        }
    };

    //set plantID
    let [addPlantID, setAddedPlantID] = useState(0);
    let [addPlantName, setAddedPlantName] = useState("");
    const newPlantID = (plantCode) => {
        if (plantCode != null) {
            const filteredPlant = plantList.filter((item) =>
                item.code.includes(plantCode)
            );
            setAddedPlantID(filteredPlant[0].id);
            setAddedPlantName(filteredPlant[0].name);
            return [filteredPlant[0].id, filteredPlant[0].name];
        } else {
            setAddedPlantID(0);
            setAddedPlantName("");
        }
    };

    //set edited rows
    const setRowHandler = (value, obj, updatedRow) => {
        const index = rows.indexOf(updatedRow);
        if (updatedRow.id != "") {
            const row = rows[index];
            row[obj] = value;
            rows[index] = row;
            setRows(rows);
        } else {
            const row = rows[index];
            row[obj] = value;
            setRows(rows);
        }

         // Validation
         if (value.length > 0) {
            if (obj === "groupName") {
                setError({ ...error, breakdownReasonGroupText: "" });
            } else if (obj === "code") {
                setError({ ...error, breakdownReasonLocationCodeText: "" });
            } else if (obj === "name") {
                setError({ ...error, breakdownReasonLocationNameText: "" });
            } else if (obj === "plantCode") {
                setError({ ...error, plantText: "" });
            }
            
        } else {
            if (obj === "groupName") {
                setError({ ...error, breakdownReasonGroupText: t("SelectABreakdownReasonGroup") });
            } else if (obj === "code") {
                setError({ ...error, breakdownReasonLocationCodeText: t("SelectABreakdownReasonLocationCode") });
            } else if (obj === "name") {
                setError({ ...error, breakdownReasonLocationNameText: t("SelectABreakdownReasonLocationName") });
            } else if (obj === "plantCode") {
                setError({ ...error, plantText: t("SelectAPlant") });
            }
        }
    };

    // Validation
    const [error, setError] = useState({
        breakdownReasonGroupText: t("SelectABreakdownReasonGroup"),
        breakdownReasonLocationCodeText: t("SelectABreakdownReasonLocationCode"),
        breakdownReasonLocationNameText: t("SelectABreakdownReasonLocationName"),
        plantText: t("SelectAPlant"),
    });
    const [isAddDisable, setIsAddDisable] = useState(true);

    useEffect(() => {
        if (addPlantID !== 0) {
            setError({ ...error, plantText: "" });
        } else {
            setError({ ...error, plantText: t("SelectAPlant") });
        }
    }, [addPlantID]);

    useEffect(() => {
        if (error.plantText === "" && error.breakdownReasonGroupText === "" && error.breakdownReasonLocationCodeText === "" && error.breakdownReasonLocationNameText === "") {
            setIsAddDisable(false);
        } else {
            setIsAddDisable(true);
        }
    }, [error]);

    const disableEditHandler = () => {
        filterData(filterText);
        setEditable(false);
        //enable edit button
        setDisableButton(false);
        setAddedPlantID(0);

        setError({
            breakdownReasonGroupText: t("SelectABreakdownReasonGroup"),
            breakdownReasonLocationCodeText: t("SelectABreakdownReasonLocationCode"),
            breakdownReasonLocationNameText: t("SelectABreakdownReasonLocationName"),
            plantText: t("SelectAPlant"),
        });
    };

    //filter table
    const [filterText, setFilterText] = useState("");

    // Filter table
    const filterData = (value) => {
        const newFilteredText = value.toLowerCase();
        setFilterText(newFilteredText);
        let filteredItems = cloneObject(initialRows).filter((item) => item.code.toLowerCase().includes(newFilteredText) || item.groupName.toLowerCase().includes(newFilteredText) || item.name.toLowerCase().includes(newFilteredText));
        setRows(filteredItems);
        setDisableButton(false);
    };

    useEffect(() => {
        filterData(filterText);
    }, [initialRows]);

    //modal
    const [isModalOpen, setModalOpen] = useState(false);
    const [deletedRow, setDeletedRow] = useState([]);
    const deleteButtonHandler = (row) => {
        setDeletedRow(row);
        toggleModal();
    };

    const toggleModal = () => {
        setModalOpen((prevState) => !prevState);
    };

    const enableEditHandler = (row) => {
        if (disableButton || editable) {
            filterData(filterText);
        }
        setDisableButton(true);
        newGroupID(row.groupName);
        newPlantID(row.plantCode);
        setAddedPlantName(row.plantName);
        setEditableRow(row.id);
        setEditable(true);

        setError({
            breakdownReasonGroupText: "",
            breakdownReasonLocationCodeText: "",
            breakdownReasonLocationNameText: "",
            plantText: "",
        });
    };

    // Delete row
    const deleteHandler = (row) => {
        toggleModal();
        let data = {
            id: row.id,
            code: row.code,
            name: row.name,
            plantId: row.plantId,
            groupId: row.groupId,
            breakdownReasonPlaceLocalizationName:
                row.breakdownReasonPlaceLocalizationName,
        };
        dispatch(deleteBreakdownReasonPlace(data));
    };

    //update and add in one function
    const updateAddHandler = (row) => {
        //update
        if (row.id !== "") {
            const data = {
                id: row.id,
                code: row.code,
                name: row.name,
                breakdownReasonPlaceLocalizationName: row.name,
                status: 1,
                plantId: row.plantId,
                groupId: addGroupID,
            };
            dispatch(updateBreakdownReasonPlace(data));
        }
        //add
        else {
            //enable add button
            const data = {
                code: row.code,
                name: row.name,
                breakdownReasonPlaceLocalizationName:
                    row.breakdownReasonPlaceLocalizationName,
                plantId: addPlantID,
                groupId: addGroupID || 0,
            };
            dispatch(addBreakdownReasonPlace(data));
        }
    };

    //add blank row for new plant addition
    const addBlankRowHandler = () => {
        setAddedPlantName("");
        setCurrentPage(0);
        //disable add button
        setDisableButton(true);
        const addedBlankRow = [
            {
                id: "",
                code: "",
                name: "",
                plantCode: "",
                groupCode: "",
                breakdownReasonPlaceLocalizationName: "",
            },
        ];
        rows = addedBlankRow.concat(rows);
        setEditableRow(addedBlankRow[0].id);
        setEditable(true);
        setRows(rows);

        setError({
            breakdownReasonGroupText: t("SelectABreakdownReasonGroup"),
            breakdownReasonLocationCodeText: t("SelectABreakdownReasonLocationCode"),
            breakdownReasonLocationNameText: t("SelectABreakdownReasonLocationName"),
            plantText: t("SelectAPlant"),
        });
    };



    // Pagination
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (_event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setCurrentPage(0);
    };

    const getPlaceCodeHandler = (groupId) => {
        dispatch(getBreakDownPlaceByGroupId(groupId));
    };

    return (
        <StyledTableDiv>
            <h1>
                {t("BreakdownPlace")} {t("List")}{" "}
            </h1>
            <AddButton
                onClick={() => addBlankRowHandler()}
                disabled={disableButton}
            />
            {pageLoaded === true ? (
                <Grid
                    container
                    spacing={4}
                    alignItems="center"
                    justifyContent="center"
                    sx={{ marginBottom: 4 }}
                >
                    <Grid item xs={12} sm={12} md={4}>
                        <SearchBar value={filterText} onChange={(newValue) => setFilterText(newValue)} onRequestSearch={(value) => filterData(value)} />
                    </Grid>
                </Grid>
            ) : null}
            <Box m={2} />
            {rows.length > 0 ? (
                <Grow
                    in={true}
                    style={{ transformOrigin: "0 0 0" }}
                    {...{ timeout: 1000 }}
                >
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    {renderTableCell([
                                        { id: "id", label: t("ID") },
                                        {
                                            id: "groupName",
                                            label: t("BreakdownGroup"),
                                        },
                                        {
                                            id: "code",
                                            label: t("BreakdownPlaceCode"),
                                        },
                                        {
                                            id: "name",
                                            label: t("BreakdownPlaceName"),
                                        },
                                        {
                                            id: "breakdownReasonPlaceLocalizationName:row.breakdownReasonPlaceLocalizationName,",
                                            label: t(
                                                "BreakdownPlaceNameLocalized"
                                            ),
                                        },
                                        {
                                            id: "plantCode",
                                            label: t("PlantCode"),
                                        },
                                        { id: "Actions", label: t("Actions") },
                                    ])}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows
                                    .slice(
                                        currentPage * rowsPerPage,
                                        currentPage * rowsPerPage + rowsPerPage
                                    )
                                    .map((row, index) => (
                                        <React.Fragment key={row.id}>
                                            <TableRow key={row.id} id={`brp_TableRow_${index}`}>
                                                <TableCell align="center" id={`brp_TableCell_${index}`}>
                                                    {row.id}
                                                </TableCell>
                                                <TableCell align="center" id={`brp_TableCell_1_${index}`}>
                                                    {editable &&
                                                    editableRow === row.id ? (
                                                        <Autocomplete
                                                            id={`brp_AutoComplete_${index}`}
                                                            aria-required={true}
                                                            defaultValue={
                                                                row.groupName
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) => {
                                                                newGroupID(
                                                                    newValue
                                                                );
                                                            }}
                                                            
                                                            options={groupList.map(
                                                                (option) =>
                                                                    option.breakdownReasonGroupLocalizationName ??
                                                                    option.name
                                                            )}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    margin="normal"
                                                                    variant="outlined"
                                                                    error={error.breakdownReasonGroupText.length > 0}
                                                                    helperText={error.breakdownReasonGroupText}
                                                                    FormHelperTextProps ={{id: "brp_val1"}}
                                                                    id={`brp_TextField_${index}`}
                                                                />
                                                            )}
                                                        />
                                                    ) : (
                                                        row.groupName
                                                    )}
                                                </TableCell>
                                                <TableCell align="center" id={`brp_TableCell_2_${index}`}>
                                                    {editable &&
                                                    editableRow === row.id ? (
                                                        <TextField
                                                            onInput={(e) =>
                                                                setRowHandler(
                                                                    e.target
                                                                        .value,
                                                                    "code",
                                                                    row
                                                                )
                                                            }
                                                            defaultValue={
                                                                row.code
                                                            }
                                                            variant="outlined"
                                                            error={error.breakdownReasonLocationCodeText.length > 0}
                                                            helperText={error.breakdownReasonLocationCodeText}
                                                            FormHelperTextProps ={{id: "brp_val2"}}
                                                            id={`brp_TextField_1_${index}`}
                                                        />
                                                    ) : (
                                                        row.code
                                                    )}
                                                </TableCell>
                                                <TableCell align="center" id={`brp_TableCell_3_${index}`}>
                                                    {editable &&
                                                    editableRow === row.id ? (
                                                        <TextField
                                                            onInput={(e) =>
                                                                setRowHandler(
                                                                    e.target
                                                                        .value,
                                                                    "name",
                                                                    row
                                                                )
                                                            }
                                                            defaultValue={
                                                                row.name
                                                            }
                                                            variant="outlined"
                                                            error={error.breakdownReasonLocationNameText.length > 0}
                                                            helperText={error.breakdownReasonLocationNameText}
                                                            FormHelperTextProps ={{id: "brp_val3"}}
                                                            id={`brp_TextField_2_${index}`}
                                                        />
                                                    ) : (
                                                        row.name
                                                    )}
                                                </TableCell>
                                                <TableCell align="center" id={`brp_TableCell_4_${index}`}>
                                                    {
                                                        row.breakdownReasonPlaceLocalizationName
                                                    }
                                                </TableCell>
                                                <TableCell align="center" id={`brp_TableCell_5_${index}`}>
                                                    {editable &&
                                                    editableRow === row.id &&
                                                    editableRow === "" ? (
                                                        <Autocomplete
                                                            id={`brp_AutoComplete_1_${index}`}
                                                            aria-required={true}
                                                            defaultValue={
                                                                row.plantCode
                                                            }
                                                            onChange={(
                                                                event,
                                                                newValue
                                                            ) => {
                                                                newPlantID(
                                                                    newValue
                                                                );
                                                            }}
                                                            options={plantList.map(
                                                                (option) =>
                                                                    option.code
                                                            )}
                                                            renderInput={(
                                                                params
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    margin="normal"
                                                                    variant="outlined"
                                                                    error={error.plantText.length > 0} 
                                                                    helperText={error.plantText}
                                                                    FormHelperTextProps ={{id: "brp_val4"}}
                                                                    id={`brp_TextField_2_${index}`}
                                                                    
                                                                />
                                                            )}
                                                        />
                                                    ) : (
                                                        row.plantCode
                                                    )}
                                                </TableCell>
                                                <TableButtons
                                                    addDisabled={isAddDisable}
                                                    editable={editable}
                                                    editableRow={editableRow}
                                                    row={row}
                                                    updateAddHandler={() =>
                                                        updateAddHandler(row)
                                                    }
                                                    disableEditHandler={() =>
                                                        disableEditHandler()
                                                    }
                                                    enableEditHandler={() =>
                                                        enableEditHandler(row)
                                                    }
                                                    deleteButtonHandler={() =>
                                                        deleteButtonHandler(row)
                                                    }
                                                />
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                            </TableBody>
                        </Table>

                        <TablePagination
                            rowsPerPageOptions={[20, 50, 100]}
                            component="div"
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={currentPage}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grow>
            ) : null}
            <Modal
                title={t("Delete")}
                content={t("WillYouDoTransaction")}
                approved={() => deleteHandler(deletedRow)}
                isModalOpen={isModalOpen}
                toggle={toggleModal}
            />
            <LoadingBackdrop />
        </StyledTableDiv>
    );
}
